import { useEffect, useState} from "react";
import useApiCallService from "../../Common/Helpers/ApiCall";
import SortableList from "../../Common/Components/Lists/SortableList";
import {CustomButton} from "../../Common/Components/Button/CustomButton";
import {Button, Card, Col, Row} from "reactstrap";
import {useNavigate} from "react-router-dom";
import {ADMIN_PATHS} from "../../config";
import AdminResponseHonorarium from "../Models/Response/AdminResponseHonorarium";
import {useTranslation} from "react-i18next";
import {CheckUserRole} from "../../AppSystem/Helpers/CheckUserRole";
import {ToCustomDecimal} from "../../AppSystem/Helpers/ToCustomDecimal";
import {CheckUserPermission} from "../../AppSystem/Helpers/CheckUserPermission";
import {UrlStructure} from "../../AppSystem/Helpers/UrlStructure";
import { useHeader } from "../../Auth/Components/Nav/HeaderContext";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";

const AdminHonorariumListHistory = ({ userId = null, isSuperAdmin = null, setActiveTab = null, returnPath = null }) => {
    const { setPageTitle, setPageTitleKey, setOnBack } = useHeader();
    isSuperAdmin = CheckUserRole("SuperAdmin");
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = CheckMobile(998);

    let idFromUrl = '';
    if (window.location.pathname.includes('admin/user-list/user')) {
        idFromUrl = new URLSearchParams(window.location.search).get('id');
    }
    const baseUrl = "/honorarium/admin/search/filter-history";

    const isReadOnly = userId && userId !== "" && userId !== "undefined";

    let permission = false;
    if (CheckUserPermission("admin") || CheckUserPermission("admin.honorarium") || CheckUserPermission("admin.honorarium.create")) {
        permission = true;
    }

    useEffect(() => {
        setPageTitle(t('honorarium.honorariumHistory'));
        setPageTitleKey('honorarium.honorariumHistory');
        setOnBack(() => {
            if (setActiveTab) {
                setActiveTab("4");
            } else {
                navigate(ADMIN_PATHS.HONORARIUM_LIST);
            }
        });
        return () => { setPageTitle(''); setPageTitleKey(''); setOnBack(null); };
    }, [t]);

    const renderActionColumn = (item) => {
        return (
            <>
                <CustomButton icon = "bx bx-show py-1" iconColor="#157553" hoverIconColor='white' hoverButtonColor='#A3C2B8' iconSize={4}  buttonColor="#cde0da"  tooltipText={t('button.info')} customClasses="rounded" buttonBorder={false} id={item.id} 
                            onClick={() => {
                                navigate(`${ADMIN_PATHS.HONORARIUM_INFO}?id=${item.id}`, {
                                    state: { returnTo: returnPath, userId: userId }
                                });
                            }} />
            </>
        );
    }

    const renderButtonColumn = (item) => {
        return (
            <>
                {permission && !isReadOnly ?
                    <Col lg={12} className="mt-4 px-3">
                        <CustomButton customClasses="rounded" text={t('honorarium.newHonorarium')} icon="bx bx-plus pe-2" onClick={() => {
                            navigate(ADMIN_PATHS.HONORARIUM)
                        }}
                        />
                    </Col>

                    : ""}
            </>
        );
    }

    const columns = [
        "visualId",
        'createdAt',
        "userName",
        "orgName",
        "costPlace",
        'firstPayment',
        'paymentInterval',
        {
            "field" : "annualHonorarium",
            "label" : t('honorarium.annual'),
            'insideClass' : (item)=> item.annualHonorarium >= 0 ? 'text-green text-end fixed-width' : 'text-red text-end fixed-width',//w-50
            "value": (item) =>  item.annualHonorarium ? ToCustomDecimal(item.annualHonorarium) + ' kr' : "",
            "type": "number"
        },
        "status"
    ];

    const columnsToExport = ["visualId", 'createdAt', "userName","orgName", "costPlace",  'firstPayment', 'paymentInterval', "annualHonorarium", "status"];

    if (isSuperAdmin === true) {
        columns.unshift('id');
    }
    const listOptions = {
        "model": AdminResponseHonorarium,
        "columns": columns,
        "actions": {
            "actionColumn" : renderActionColumn,
            "addButton": renderButtonColumn,
        },
        "exportIsAvailable": true,
        "urlGetListItemsToExport": baseUrl + (idFromUrl ? `?id=${idFromUrl}` : ''),
        "nameFile": t('honorarium.honorariumHistory'),
        "ignoreFields" : columnsToExport,
        "modelType" : "Honorarium-History",
        "filterTestIsAvailable": true,
        "urlGetSearch" : baseUrl,
        "viewName": "AdminHonorariumListHistory",
        "ignoreUrlParams": !!idFromUrl,

    };

    return (
        <>
            {!isReadOnly && !isMobile && (
                <Col lg={12} className="px-0">
                    <CustomButton
                        text={t('button.back')}
                        icon={'bx bx-chevron-left'}
                        buttonSize={'small'}
                        customClasses={'mb-3 ms-3 backButton'}
                        onClick={() => {
                            if (setActiveTab) {
                                setActiveTab("4");
                            } else {
                                navigate(ADMIN_PATHS.HONORARIUM_LIST);
                            }
                        }}
                    />
                </Col>
            )}

            <Col lg="12" className="card card-backend p-4 mb-5">
                <Row>
                    <Col lg={6}>
                        <h2 className="pb-2 ps-1 rokkitt-font">
                            {t('honorarium.honorariumHistory')}
                        </h2>
                    </Col>

                    {isReadOnly && (
                        <Col lg={6} className="text-end">
                            <Button
                                className="bg-green"
                                onClick={() => {
                                    if (setActiveTab) {
                                        setActiveTab("4");
                                    } else {
                                        navigate(ADMIN_PATHS.HONORARIUM_LIST);
                                    }
                                }}
                            >
                                {t('openPayment.myItems')}
                            </Button>
                        </Col>
                    )}
                </Row>
                <SortableList
                    listOptions={listOptions}
                />
        </Col>
        </>
    );
};

export default AdminHonorariumListHistory;